import { FlatPermission } from "../interface/permissions";

export function can(map: Map<string, FlatPermission>, key: string): boolean {
  let node = map.get(key);
  if (!node) return false; // unknown key → default deny

  while (node) {
    if (!node.enabled) return false;
    node = node.parentKey ? map.get(node.parentKey) : undefined;
  }
  return true;
}

export function canAction(
  map: Map<string, FlatPermission>,
  key: string,
  action: string
): boolean {
  return can(map, key) && (map.get(key)?.actions?.[action] ?? false);
}

export function canAny(map: Map<string, FlatPermission>, keys: string[]): boolean {
  return keys.some((k) => can(map, k));
}

export function canAll(map: Map<string, FlatPermission>, keys: string[]): boolean {
  return keys.every((k) => can(map, k));
}